import { useNavigate } from 'react-router-dom';
import { useTenantStore } from '@/store/tenantStore';
import { getLogoImageUrl } from '@/services/tenant/tenantImages';
import { analyticsService } from '@/services/analytics/analyticsService';
import { ROUTES } from '@/app/router/routes';
import styles from './AuthLayout.module.css';

/**
 * MobileAuthHeader — the logo bar at the top of the login and sign-up forms on mobile.
 *
 * Mirrors Flutter WebMobileHeaderForAuthWidgets (web_login/web_mobile_header_for_auth.dart):
 * the colored logo, at most 40px high and 50.w wide, left-aligned on white with 5.w × 2.5.h
 * padding; tapping it goes home.
 */
export function MobileAuthHeader() {
  const navigate = useNavigate();
  const { content } = useTenantStore();
  const logoUrl = getLogoImageUrl(content);
  const brandName = content?.contentSettings?.general?.name ?? '';

  return (
    <div className={styles.mobileHeader}>
      <button
        type="button"
        className={styles.mobileHeaderLogoBtn}
        onClick={() => {
          void analyticsService.logScreenView({ screenName: ROUTES.HOME });
          navigate(ROUTES.HOME);
        }}
      >
        {logoUrl && <img src={logoUrl} alt={brandName} className={styles.mobileHeaderLogo} />}
      </button>
    </div>
  );
}
